<rask-fieldset-toggle
  label="RH-nummer"
  [formGroup]="form"
  [defaultExpanded]="open"
  [nrOfSelectedFilters]="filterLength"
>
  <rask-input
    label="RH-nummer"
    class="w-100"
    formControlName="redovisningshanvisning"
  >
  </rask-input>
</rask-fieldset-toggle>
